import React from 'react'
import PropTypes from 'prop-types'
import { Factory } from '~/editors/attributes';
  
function createDetails( node, props ) {
  if ( node == null ) {
    return <div />;
  }
  switch ( node.type ) {
    case 'root': return <div />;// return new RootItem( props );
    case 'group': return <div />;// return new GroupItem( props );
    case 'attribute': {
      return Factory.createEditor( node.attribute, props.blueprint, props );
    }
    default:
      return <div>No options</div>;
  }
}

export default {
  createDetails
}
